<template>
    <section class="map-wrapper">
        <h3 class="title-content">
            {{ $t('DOCTOR_CONSULTATIONS') }}
        </h3>
        <p>{{ $t('ANOTHER_CONSULTATION') }}</p>
        <p>{{ $t('WE_HAVE_PREPARED') }}</p>

        <div class="row mt-4 mb-4">
            <div class="col-xs-12">
                <GmapAutocomplete :placeholder="$t('INSERT_LOCALIZATION')" class="text-input" @place_changed="setPlace">
                </GmapAutocomplete>
            </div>
        </div>

        <div class="map-container">
            <gmap-map
                :center="center"
                :zoom="zoom"
                :options="{ styles: mapStyles }"
                style="width: 100%; height: 550px"
                ref="map"
            >
                <gmap-marker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    :options="{ styles: mapStyles }"
                    :clickable="true"
                    map-type-id="satellite"
                    :icon="icon"
                    @click="show(m)"
                >
                    <gmap-info-window v-if="m.showInfoWindow" @closeclick="show(m)">
                        <p>
                            <strong>{{ m.info.name }}</strong>
                        </p>
                        <p>{{ m.info.addres.street }}</p>
                        <p>{{ m.info.addres.postcode }}, {{ m.info.addres.city }}</p>
                        <p>{{ m.info.phone1 }}</p>
                        <p>{{ m.info.phone2 }}</p>

                        <a
                            :href="
                                `https://www.google.pl/maps/place/` +
                                    m.info.addres.street +
                                    `-` +
                                    m.info.addres.postcode +
                                    `-` +
                                    m.info.addres.city
                            "
                            target="_blank"
                            class="arrow-link mt-3"
                            >{{ $t('SEE_IN_GOOGLE_MAPS') }} <img src="./../../../assets/images/arrow-red.png" />
                        </a>
                    </gmap-info-window>
                </gmap-marker>
            </gmap-map>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            zoom: 9,
            icon: {
                url: require('./../../../assets/images/icons/marker.png'), // url
                scaledSize: new google.maps.Size(28, 28), // scaled size
                origin: new google.maps.Point(0, 0), // origin
                anchor: new google.maps.Point(0, 0), // anchor
            },

            // w tym miejscu ustalamy jak ma wyglądać (kolorystycznie)
            // nasza mapa i jej poszczególne elementy
            mapStyles: [
                {
                    featureType: 'water',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#e9e9e9',
                        },
                        {
                            lightness: 17,
                        },
                    ],
                },
                {
                    featureType: 'landscape',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#f5f5f5',
                        },
                        {
                            lightness: 20,
                        },
                    ],
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                        {
                            lightness: 17,
                        },
                    ],
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                        {
                            lightness: 29,
                        },
                        {
                            weight: 0.2,
                        },
                    ],
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                        {
                            lightness: 18,
                        },
                    ],
                },
                {
                    featureType: 'road.local',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                        {
                            lightness: 16,
                        },
                    ],
                },
                {
                    featureType: 'poi',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#f5f5f5',
                        },
                        {
                            lightness: 21,
                        },
                    ],
                },
                {
                    featureType: 'poi.park',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#dedede',
                        },
                        {
                            lightness: 21,
                        },
                    ],
                },
                {
                    elementType: 'labels.text.stroke',
                    stylers: [
                        {
                            visibility: 'on',
                        },
                        {
                            color: '#ffffff',
                        },
                        {
                            lightness: 16,
                        },
                    ],
                },
                {
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            saturation: 36,
                        },
                        {
                            color: '#333333',
                        },
                        {
                            lightness: 40,
                        },
                    ],
                },
                {
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'transit',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#f2f2f2',
                        },
                        {
                            lightness: 19,
                        },
                    ],
                },
                {
                    featureType: 'administrative',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#fefefe',
                        },
                        {
                            lightness: 20,
                        },
                    ],
                },
                {
                    featureType: 'administrative',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            color: '#fefefe',
                        },
                        {
                            lightness: 17,
                        },
                        {
                            weight: 1.2,
                        },
                    ],
                },
            ],

            // centrowanie mapy na start
            center: {
                lat: 52.6159449,
                lng: 20.3849719,
            },

            // markery do naszej mapy
            markers: [
                {
                    position: { lat: 52.6159449, lng: 20.3849719 },
                    info: {
                        status: true,
                        name: 'Apteka',
                        addres: {
                            street: 'Siemieńskiego',
                            postcode: '37-500',
                            city: 'Warszawa',
                        },
                        phone1: '22 512 45 67',
                        phone2: '+48 512 345 456',
                    },
                    showInfoWindow: false,
                },
                {
                    position: { lat: 52.392459, lng: 20.923453 },
                    info: {
                        status: true,
                        name: 'Apteka 2',
                        addres: {
                            street: 'Warszawska',
                            postcode: '31-500',
                            city: 'Warszawa',
                        },
                        phone1: '22 515 25 34',
                        phone2: '+48 354 432 346',
                    },
                    showInfoWindow: false,
                },
            ],
        };
    },
    methods: {
        // metoda centrująca mapę na podstawie naszej geolokalizacji
        geolocation() {
            navigator.geolocation.getCurrentPosition(position => {
                this.currentLocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                this.center = {
                    lat: this.currentLocation.lat,
                    lng: this.currentLocation.lng,
                };
                this.zoom = 12;
            });
        },

        // metoda wykorzystywana podczas wpisywania lokalizacji
        // z autocomplete googla
        setPlace(place) {
            this.place = place;
            this.center = {
                lat: this.place.geometry.location.lat(),
                lng: this.place.geometry.location.lng(),
            };
            this.zoom = 16;
        },
        show(marker) {
            marker.showInfoWindow = !marker.showInfoWindow;
            this.center = {
                lat: marker.position.lat,
                lng: marker.position.lng,
            };
            this.zoom = 16;
        },
        hide() {
            this.showInfoWindow = !this.showInfoWindow;
            this.zoom = 9;
        },
    },
    watch: {
        $route(to, from) {
            // Call resizePreserveCenter() on all maps
            Vue.$gmapDefaultResizeBus.$emit('resize');
        },
    },
};
</script>

<style scoped>
.map-wrapper {
    display: none;
    border: 1px solid #ccc;
    float: right;
    margin: 30px 0;
    padding: 30px;
    width: calc(100% - 275px);
}

.map-container {
    border: 1px solid #ccc;
    padding: 15px;
}

.arrow-link img {
    height: 7px;
    margin: 0 0 0 5px;
}

p {
    margin-bottom: 5px;
}

@media (max-width: 1100px) {
    .map-wrapper {
        width: calc(100% - 227px);
    }
}

@media (max-width: 991px) {
    .map-wrapper {
        width: 100%;
        float: left;
    }
}
</style>



// WEBPACK FOOTER //
// maps.vue?4b3d7852